import { Link, useNavigate } from 'react-router-dom';
import searchicon from '../assets/images/search.png';
import empty_table from '../assets/images/empty_table.png';

import { getMembers } from '../slices/member';
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from 'react';
import Header from './dt/dt';
import Pagination from './dt/Pagination';
import { useTranslation } from 'react-i18next';

const Members = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { members } = useSelector((state) => state.member);
    const { user } = useSelector((state) => state.auth);

    let PageSize = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const [searchType, setSearchType] = useState("");
    const [search, setSearch] = useState("");
    const {t} = useTranslation();

    const [defaultSort, setSort] = useState({ 'sort_column': 'head_name', 'sort_type': 'desc' });

    let defult = {
        page: currentPage,
        sort_type: defaultSort.sort_type,
        sort_by: defaultSort.sort_column,
        search_type: searchType,
        search: search,
    };

    useEffect(() => {
        if(user && user.approve == "N") {
            navigate('/profile');
        }

        dispatch(getMembers(defult));
    }, [dispatch]);

    const changePageSize = (pageNumber) => {
        setSort({ 'sort_column': 'head_name', 'sort_type': 'desc' });
        setCurrentPage(pageNumber);
        defult = {
            page: pageNumber,
            sort_type: 'desc',
            sort_by: 'head_name',
            search_type: searchType,
            search: search,
        };
        dispatch(getMembers(defult));
    }

    const columns_data = [
        {
            key: "head_name",
            text: t('name_of_the_head'),
            className: "",
            align: "left",
            sortable: true,
            defaultSort: false,
        },
        {
            key: "phone_number",
            text: t("contact_no"),
            className: "",
            align: "left",
            sortable: true,
            defaultSort: false,
        },
        {
            key: "village",
            text: t("village"),
            className: "",
            align: "left",
            sortable: true,
            defaultSort: false,
        },
        {
            key: "block",
            text: t("block"),
            className: "",
            sortable: true,
            align: "left",
            defaultSort: false,
        },
        {
            key: "district",
            text: t("district"),
            className: "",
            sortable: true,
            defaultSort: 'asc',
        },
        {
            key: "action",
            text: t("action"),
            className: "",
            sortable: false,
            align: "left",
            defaultSort: false,
        }
    ];

    const [columns, setColumns] = useState(columns_data);

    const clickaction = (column, type, index) => {
        setSort({ 'sort_column': column, 'sort_type': type });
        setCurrentPage(1);
        defult = {
            page: 1,
            sort_type: type,
            sort_by: column,
            search_type: searchType,
            search: search,
        };

        dispatch(getMembers(defult));
    }

    const filterType = (e) => {
        setSearchType(e.target.value);
    }
    const searchValue = (e) => {
        setSearch(e.target.value);
    }

    const filterResult = () => {
        setSort({ 'sort_column': 'head_name', 'sort_type': 'desc' });
        setCurrentPage(1);
        defult = {
            page: 1,
            sort_type: 'desc',
            sort_by: 'head_name',
            search_type: searchType,
            search: search,
        };
        dispatch(getMembers(defult));
    }

    return (
        <div className="container">
            <section className="mt-5 pt-5">
                <div className="row">
                    <div className='col-md-12'>
                        <div className='section-title' id='heading_title'>
                            <h1><span className='font-color-1'>{t('allMembers')}</span></h1>
                            {/* <p className='mb-0'>{t('section_text1')}<br/>{t('section_text2')}</p> */}
                        </div>
                    </div>
                </div>
                <div className="row mt-2-5">
                    <div className='col-md-4 mb-3'>
                        <div className='form-card'>
                            <select className='form-control rightArrow memberSearch' onChange={e => filterType(e)}>
                                <option value="">{t('choose')}</option>
                                <option value="head_name">{t('name')}</option>
                                <option value="business_name">{t('business')}</option>
                                <option value="department">{t('services')}</option>
                                <option value="position">{t('position')}</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-4 mb-3'>
                        <div className='form-card'>
                            <div className='table-search'>
                                <input type='search' className='form-control memberSearch' placeholder={t('search_here')} onChange={e => searchValue(e)} />
                                <img src={searchicon} />
                            </div>
                        </div>
                    </div>
                    <div className='col-md-2 mb-3'>
                        <div class="table-search-btn"><button class="btn btn-primary btn-block" onClick={() => filterResult()}>{t('search')}</button></div>
                    </div>
                </div>
                <div className="row">
                    <div className='col-md-12 mt-2-5'>
                        <div className='table-area bg-2 font-color'>
                            <div className='table-responsive'>
                                <table className='table '>
                                    <Header config={columns} handleClick={clickaction} defaultSort={defaultSort} />

                                    <tbody>
                                        {
                                            members != null && members.total > 0 ?
                                                members?.users.map((item, index) => {
                                                    return (<tr key={index}>
                                                        <td>{item.head_name}</td>
                                                        <td>{item.phone_number}</td>
                                                        <td>{item.village}</td>
                                                        <td>{item.block}</td>
                                                        <td>{item.district}</td>
                                                        <td>
                                                            <Link className='btn btn-primary btn-sm ms-3' to={`/member/${item.id}`}><i className='fa fa-eye'></i></Link>
                                                        </td>
                                                    </tr>);
                                                })
                                                :
                                                <tr>
                                                    <td colSpan={6} className='text-center'>
                                                        <div className='emptyTable'>
                                                            <img src={empty_table} />
                                                            <h5 className='mt-2-new'>No Data Found</h5>
                                                        </div>
                                                    </td>
                                                </tr>
                                        }

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12'>
                        <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            totalCount={members ? members.total : 1}
                            pageSize={PageSize}
                            onPageChange={page => changePageSize(page)}
                        />
                    </div>

                </div>
            </section>
        </div>
    );
}
export default Members;